import apiClient from '../../config/api';

/**
 * Paquetes de funcionalidades (feature-106).
 *
 * Espejo del catálogo del backend (`backend/src/modules/entitlements/catalog.ts`).
 * El backend es quien decide; aquí solo se usa para pintar y ocultar.
 */
export const FEATURE_KEYS = [
  'magic_dictation',
  'magic_writing',
  'direct_generation',
  'traditional_dictation',
  'classification',
  'patient_summary',
  'presave_check',
  'few_shot',
  'snomed',
  'anatomic_regions',
  'imaging_modality',
  'faq',
  'template_import',
  'template_name_variants',
  'batch_dictation',
] as const;

export type FeatureKey = (typeof FEATURE_KEYS)[number];

export const REQUEST_FEATURES: readonly FeatureKey[] = [
  'magic_dictation',
  'magic_writing',
  'direct_generation',
  'traditional_dictation',
  'classification',
];

export interface MyEntitlements {
  features: FeatureKey[];
  quotaExceeded: boolean;
}

/** Sin suscripción en vigor, o si la consulta falla, la cuenta tiene todo (D-22): el backend es la barrera. */
export const ALL_ENTITLEMENTS: MyEntitlements = { features: [...FEATURE_KEYS], quotaExceeded: false };

export async function getMyEntitlements(): Promise<MyEntitlements> {
  const { data } = await apiClient.get<MyEntitlements>('/entitlements/me');
  return data;
}

/** Nivel del aviso de consumo (F6): umbral parcial, 100 %, exceso o tope de extras. */
export type UsageAlertLevel = 'warn' | 'full' | 'over' | 'cap';

export interface UsageAlert {
  key: string;
  level: UsageAlertLevel;
  /** % de contratados (`warn`/`full`) o del tope (`cap`); `null` en `over`. */
  value: number | null;
  facturables: number;
  contratados: number;
  extras: number;
  cap: number | null;
  cycleEnd: string;
}

/** Aviso del ciclo en curso para el admin de la cuenta; `null` para el resto o si lo cerró. */
export async function getMyUsageAlert(): Promise<UsageAlert | null> {
  const { data } = await apiClient.get<{ alert: UsageAlert | null }>('/entitlements/alert');
  return data.alert;
}

export async function dismissMyUsageAlert(): Promise<void> {
  await apiClient.post('/entitlements/alert/dismiss');
}
